module.exports = "http://cdn.realive.com.ua/src/views/donate/main/assets/images/menu/shop.png";